import uniqueId from 'lodash/uniqueId';
import React from 'react';
import { useDispatch } from 'react-redux';

import {
  trackBibClick as trackBibClickAnalytics,
  trackBibsRowTitleClick as trackBibsRowTitleClickAnalytics,
  trackLinksRowLinkClick as trackLinksRowLinkClickAnalytics,
  trackListCreatorClick as trackListCreatorClickAnalytics,
  trackListImageClick as trackListImageClickAnalytics,
  trackListImpression as trackListImpressionAnalytics,
  trackListTitleClick as trackListTitleClickAnalytics,
  trackNavLinkClick as trackNavLinkClickAnalytics
} from 'app/actions/AnalyticsGa4Actions/browse/rowsActions';
import Rows from 'app/components/shared/browse/Rows';
import { UI_CONTAINER_TYPE } from 'app/constants/AnalyticsGa4Constants';
import { ROW_CHILD_COMPONENT_TYPE } from 'app/constants/browse/rows';
import { mapCategoriesToNavRowLinks } from 'app/helpers/browse';
import { expandCategoryPath } from 'app/helpers/browse/categories';
import { uiCategoryConfigMapShape } from 'app/shapes/browse';

const BrowseCategoryNodePageContainer = ({ browseCategoryConfig }) => {
  const dispatch = useDispatch();

  const bibsByCategoryPath = browseCategoryConfig.get('bibsByCategoryPath')?.toJS() ?? {};
  const categoryByPath = browseCategoryConfig.get('categoryByPath');
  const categoryPath = browseCategoryConfig.get('categoryPath');

  const category = categoryByPath.get(categoryPath);
  const subCategoryPaths = category.get('subCategoryPaths').toArray();
  const categoryTitle = category.get('title');

  // TODO: confirm screen-reader title
  const screenReaderNavTitle = `Browse ${categoryTitle} by category`;

  const navRowLinks = mapCategoriesToNavRowLinks(
    subCategoryPaths.map(nextCategoryPath => categoryByPath.get(nextCategoryPath)?.toJS()).filter(Boolean)
  );

  const categoryPaths = expandCategoryPath(categoryPath);
  const browseEntity = {
    browse_category: browseCategoryConfig.getIn(['categoryByPath', categoryPaths[0], 'title']),
    browse_category_1: browseCategoryConfig.getIn(['categoryByPath', categoryPaths[1], 'title']),
    browse_category_2: browseCategoryConfig.getIn(['categoryByPath', categoryPaths[2], 'title'])
  };

  const displayBibRows = subCategoryPaths.map((nextCategoryPath, index) => {
    const nextCategory = categoryByPath.get(nextCategoryPath)?.toJS() ?? {};
    const { title = '' } = nextCategory;
    const titleUrl = `/v2/browse${nextCategoryPath}`;
    const rowPosition = index + 2;

    return {
      additionalAnalyticsPayload: {
        entities: {
          browse: browseEntity
        },
        uiContainerType: UI_CONTAINER_TYPE.BROWSE_ROW_BIB
      },
      hasAlternativeStyle: false,
      childComponent: {
        mappedProps: {
          displayBibs: bibsByCategoryPath[nextCategoryPath] ?? [],
          hasHistoryRoutingForTitles: true,
          rowPosition,
          title,
          titleUrl
        },
        type: ROW_CHILD_COMPONENT_TYPE.BIBS
      },
      rowId: uniqueId(`${ROW_CHILD_COMPONENT_TYPE.BIBS}_`)
    };
  });

  const rows = [
    {
      additionalAnalyticsPayload: {
        entities: {
          browse: browseEntity
        },
        uiContainerType: UI_CONTAINER_TYPE.BROWSE_ROW_NAV
      },
      hasAlternativeStyle: false,
      childComponent: {
        mappedProps: {
          links: navRowLinks,
          title: screenReaderNavTitle
        },
        type: ROW_CHILD_COMPONENT_TYPE.NAV
      },
      rowId: uniqueId(`${ROW_CHILD_COMPONENT_TYPE.NAV}_`)
    }
  ].concat(displayBibRows);

  const trackBibClick = payload => dispatch(trackBibClickAnalytics(payload));
  const trackBibsRowTitleClick = payload => dispatch(trackBibsRowTitleClickAnalytics(payload));
  const trackLinksRowLinkClick = payload => dispatch(trackLinksRowLinkClickAnalytics(payload));
  const trackListCreatorClick = payload => dispatch(trackListCreatorClickAnalytics(payload));
  const trackListImageClick = payload => dispatch(trackListImageClickAnalytics(payload));
  const trackListImpression = payload => dispatch(trackListImpressionAnalytics(payload));
  const trackListTitleClick = payload => dispatch(trackListTitleClickAnalytics(payload));
  const trackNavLinkClick = payload => dispatch(trackNavLinkClickAnalytics(payload));

  return (
    <Rows
      rows={rows}
      trackBibClick={trackBibClick}
      trackBibsRowTitleClick={trackBibsRowTitleClick}
      trackLinksRowLinkClick={trackLinksRowLinkClick}
      trackListCreatorClick={trackListCreatorClick}
      trackListImageClick={trackListImageClick}
      trackListImpression={trackListImpression}
      trackListTitleClick={trackListTitleClick}
      trackNavLinkClick={trackNavLinkClick}
    />
  );
};

BrowseCategoryNodePageContainer.propTypes = {
  browseCategoryConfig: uiCategoryConfigMapShape.isRequired
};

export default BrowseCategoryNodePageContainer;
